// // import React, { Component } from "react";
// // import { roomListColumn } from "./RoomListTableData";
// // import DataTable from "../../../../../Common/DataTable/DataTable";
// // import DataTableHeader from "../../../../../Common/DataTableHeader/DataTableHeader";
// // import DataTableFooter from "../../../../../Common/DataTableFooter/DataTableFooter";

// // class RoomListTable extends Component {
// //   constructor(props) {
// //     super(props);
// //     this.state = {
// //       dataT: [],
// //     };
// //   }

// //   componentDidMount() {
// //     this.formatData(this.props.rooms);
// //   }

// //   componentDidUpdate(prevProps) {
// //     if (prevProps.rooms !== this.props.rooms) {
// //       this.formatData(this.props.rooms);
// //     }
// //   }

// //   formatData = (rooms) => {
// //     if (!rooms || rooms.length === 0) {
// //       this.setState({ dataT: [] });
// //       return;
// //     }

// //     const formatted = rooms.map((room) => ({
// //       id: room.id,
// //       roomNumber: room.room_number,
// //       roomType: room.type || "-",
// //       roomPrice: room.room_price,
// //       bedCharge: room.extra_bed_charge,
// //       capacity: room.capacity,
// //       roomSize: room.room_size,
// //       bedType: room.bed_type,
// //       actions: (
// //         <>
// //           <button
// //             type="button"
// //             className="btn"
// //             data-bs-toggle="offcanvas"
// //             data-bs-target="#edit-room"
// //             aria-controls="edit-room"
// //             onClick={() =>
// //               window.dispatchEvent(
// //                 new CustomEvent("open-edit-room", { detail: room.id })
// //               )
// //             }
// //           >
// //             <i className="bi bi-pencil-square"></i>
// //           </button>
// //           <button
// //             type="button"
// //             className="btn deleterow"
// //             onClick={() => this.props.onDelete?.(room.id)}
// //           >
// //             <i className="bi bi-trash text-danger"></i>
// //           </button>
// //         </>
// //       ),
// //     }));

// //     this.setState({ dataT: formatted });
// //   };

// //   render() {
// //     const { dataT } = this.state;
// //     const { loading } = this.props;

// //     return (
// //       <>
// //         <DataTableHeader />
// //         {loading ? (
// //           <p className="text-center py-4">Loading...</p>
// //         ) : (
// //           <DataTable columns={roomListColumn} data={dataT} />
// //         )}
// //         <DataTableFooter dataT={dataT} />
// //       </>
// //     );
// //   }
// // }

// // export default RoomListTable;

// import React from "react";
// import { roomListColumn } from "./RoomListTableData";
// import DataTable from "../../../../../Common/DataTable/DataTable";
// import DataTableHeader from "../../../../../Common/DataTableHeader/DataTableHeader";
// import DataTableFooter from "../../../../../Common/DataTableFooter/DataTableFooter";

// const RoomListTable = ({ rooms = [], loading, onEdit, onDelete }) => {
//   const dataT = rooms.map((room, index) => {
//     return {
//       id: index + 1,
//       roomNumber: room.room_number,
//       roomType: room.type || "-",
//       roomPrice: room.room_price,
//       bedCharge: room.extra_bed_charge,
//       capacity: room.capacity,
//       roomSize: room.room_size,
//       bedType: room.bed_type,

//       actions: (
//         <>
//           <button
//             type="button"
//             className="btn"
//             data-bs-toggle="offcanvas"
//             data-bs-target="#edit-room"
//             aria-controls="edit-room"
//             // onClick={() => onEdit?.(room)}
//             onClick={() =>
//               window.dispatchEvent(
//                 new CustomEvent("open-edit-room", { detail: room.id })
//               )
//             }
//           >
//             <i className="bi bi-pencil-square"></i>
//           </button>

//           <button
//             type="button"
//             className="btn deleterow"
//             onClick={() => onDelete?.(room.id)}
//           >
//             <i className="bi bi-trash text-danger"></i>
//           </button>
//         </>
//       ),
//     };
//   });

//   return (
//     <>
//       <DataTableHeader />

//       {loading ? (
//         <p className="text-center py-4">Loading...</p>
//       ) : (
//         <DataTable columns={roomListColumn} data={dataT} />
//       )}

//       <DataTableFooter dataT={dataT} />
//     </>
//   );
// };

// export default RoomListTable;

// Components/RoomTable.jsx
import React from "react";
import DataTableHeader from "../../../../../Common/DataTableHeader/DataTableHeader";
import DataTable from "../../../../../Common/DataTable/DataTable";
import { roomColumns } from "./RoomListTableData";

const RoomTable = ({ data, loading, onEdit, onDelete }) => {
  const tableData = data.map((r, idx) => ({
    sno: idx + 1,
    room_number: r.room_number,
    room_type: r.room_type?.name || r.room_type_name || "-",
    room_size:
      (r.room_size || "-").charAt(0).toUpperCase() +
      (r.room_size || "-").slice(1).toLowerCase(),
    capacity: r.capacity ?? "-",
    status: r.status ? (
      <span className="badge bg-info text-dark">{r.status}</span>
    ) : (
      <span className="badge bg-secondary">-</span>
    ),
    housekeeping: r.housekeeping_status ? (
      <span className="badge bg-warning text-dark">
        {r.housekeeping_status}
      </span>
    ) : (
      <span className="badge bg-secondary">-</span>
    ),
    maintenance: r.is_maintenance ? (
      <span className="badge bg-danger">Yes</span>
    ) : (
      <span className="badge bg-success">No</span>
    ),
    actions: (
      <>
        <button
          className="btn btn-sm btn-outline-primary me-2"
          onClick={() => onEdit(r)}
        >
          <i className="bi bi-pencil-square" />
        </button>
        <button
          className="btn btn-sm btn-outline-danger"
          onClick={() => onDelete(r.id)}
        >
          <i className="bi bi-trash" />
        </button>
      </>
    ),
  }));

  return (
    <>
      <DataTableHeader />
      {loading ? (
        <div className="text-center py-4">
          <div className="spinner-border" />
        </div>
      ) : (
        <DataTable columns={roomColumns} data={tableData} />
      )}
    </>
  );
};

export default RoomTable;
